import ExperienceCreate from "./ExperienceCreate";
import ExperienceEdit from "./ExperienceEdit";
import ExperienceList from "./ExperienceList";

export { SourceExperience } from "./Constant/Constant";

export default {
  create: ExperienceCreate,
  edit: ExperienceEdit,
  list: ExperienceList,
};
